import "./App.css";

import React, { useState, useRef, useMemo, useEffect} from "react";

import MobileCard from "./components/MobileCard";
import ScreenImage from "./components/ScreenImage";
import Title from "./components/Title";
import GraphicMat from "./components/GraphicMat"
import ScrollVideo from "./components/ScrollVideo";
import { ProgressBar } from "./components/ProgressBar";
import LoadingSpinner from "./components/LoadingSpinner";
import NavBar from "./components/NavBar";


import { processData } from "./data/process";
import mobile_data from "./data/mobile_data";

function MobileApp() {
  const {
    frames,
    slides: allSlides,
  } = useMemo(() => {
    return processData(mobile_data);
  }, []);

  const [currentSlide, setCurrentSlide] = useState(0);
  //console.log(currentSlide);

  const ref = useRef();

  const allWrapperStyle = {
    position: "relative",
    overflowY: "scroll",
    overflowX: "hidden",
    height: "100vh",
    width: "100vw",
  };

  
  const TOTAL_FRAMES = 992;
  const FIFTH_FRAMES = 150;


  const [imgsLoaded, setImgsLoaded] = useState(false)

  useEffect(() => {

    const imgs = []
    for  (var i = 0; i < FIFTH_FRAMES; i++){
        const formattedFrame = i.toString().padStart(3, "0");
        imgs[i]=`FramesMobile/AlSina_MobFrame${formattedFrame}.jpg`
    }
    //console.log (imgs)

    const promises  = imgs.map ((src)=> {
      return new Promise ((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = src;
      });
    });

    Promise.all(promises).then((res) =>
    setImgsLoaded(true))
  }, []);

  useEffect(() => {

    const imgs = []
    for  (var i = FIFTH_FRAMES; i < TOTAL_FRAMES; i++){
        const formattedFrame = i.toString().padStart(3, "0");
        imgs[i]=`FramesMobile/AlSina_MobFrame${formattedFrame}.jpg`
    }
    //console.log (imgs)

    const promises  = imgs.map ((src)=> {
      return new Promise ((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => reject(err));
        img.src = src;
      });
    });

  }, []);

  

  const renderMobileSlides = (slidesList) => {
    return (
      <div id="all-cards-container">
        <MobileCard
          slidesContent={slidesList}
          callbackFromParent={setCurrentSlide}
        />
      </div>
    );
  };

  

  return (
        imgsLoaded ? (
      <div id={"all"} ref={ref} style={allWrapperStyle}>
      <NavBar isMobile={true} currentSlide={allSlides[currentSlide]} elementId="all" />
      <ProgressBar elementId="all" />
      {ref.current ? (
      <ScrollVideo
            divRef={ref}
            chapterStartSlide={0}
            currentSlide={allSlides[currentSlide]}
            videoSettings={frames}
            isMobile={true}
          />
        ) : null}
      <ScreenImage isMobile={true} currentSlide={allSlides[currentSlide]} />
      <Title isMobile={true} currentSlide={allSlides[currentSlide]} />
      <GraphicMat isMobile={true} currentSlide={allSlides[currentSlide]} />
      {renderMobileSlides(allSlides)}
      </div>)    
    : (<LoadingSpinner isMobile={false}/>)
    );
  }

export default MobileApp;
